module.exports = __webpack_public_path__ + "img/icon_background_music.a84f2159.svg";